import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  root: {
    marginBottom: Spacings.s4,
    display: 'flex',
    flexDirection: 'column',
    gap: Spacings.s12,
    '& > ul > li:first-child': {
      paddingLeft: 0,
    },
    [BreakPointsMedia.MD]: {
      padding: [0, 12],
    },
    [BreakPointsMedia.SM]: {
      padding: [0, 12],
    },
    [BreakPointsMedia.XS]: {
      padding: [0, 12],
    },
    [BreakPointsMedia.XXS]: {
      padding: [0, 12],
    },
  },
});

export default useStyles;
